import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addFarmDataSubmission } from "services";

import { invalidateFieldPracticesByFarmId } from "utils";

import { ADD_FARM_DATA_SUBMISSION, GET_FARM_DATA_SUBMISSION_STATUS, GET_FARM_REPORTING_YEAR } from "consts";

export const useAddFarmSubmission = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_FARM_DATA_SUBMISSION, farmId],
    mutationFn: addFarmDataSubmission,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DATA_SUBMISSION_STATUS, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_REPORTING_YEAR, farmId] });
      // after we move to the new reporting year, we need to invalidate the field practices for all fields in the farm to get the new crop confirmation status
      invalidateFieldPracticesByFarmId(farmId);
    },
  });
};
